/** Agrega la hoja bancaria adjunta al final de un documento jsPDF. */
import ptcImage from '../../imagenes/ptc.jpg';

export function appendBankInformationPage(doc) {
  const pageW = doc.internal.pageSize.getWidth();
  const pageH = doc.internal.pageSize.getHeight();
  const orientation = pageW > pageH ? 'landscape' : 'portrait';
  doc.addPage('a4', orientation);

  const margin = 17;
  const logoW = 65;
  const logoProps = doc.getImageProperties(ptcImage);
  const logoH = (logoProps.height * logoW) / logoProps.width;
  doc.addImage(ptcImage, 'JPEG', margin, 34, logoW, logoH);

  doc.setTextColor(0, 0, 0);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(8.5);
  doc.text('Información Bancaria', margin + 1, 104);

  const labelX = margin + 1;
  const valueX = 52;
  const lineH = 4.2;
  const textRows = [
    ['Beneficiario', 'Palm Trade Chile SPA'],
    ['Identificador Fiscal', 'RUT 77.710.540-K'],
    ['Dirección', 'Avenida Presidente Kennedy 5146 oficina 51 Vitacura, Santiago , Chile'],
  ];
  let y = 116;
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(8);
  textRows.forEach(([label, value]) => {
    doc.text(label, labelX, y);
    doc.text(value, valueX, y);
    y += lineH;
  });

  y += 8;
  const bankRows = [
    ['Banco Beneficiario', 'BCI Miami Branch'],
    ['Dirección', '200 South Biscayne Blvd., Suite 2300 Miami, FL  33131 ,USA'],
    ['ABA :', '66014726'],
    ['Swift:', 'CREDUS3M'],
    ['Cuenta', '120010814'],
  ];
  bankRows.forEach(([label, value]) => {
    doc.text(label, labelX, y);
    doc.text(value, valueX, y);
    y += lineH;
  });
  return doc;
}
